import React, { FC, useState, useEffect, useMemo } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { map, keyBy } from '@dt/fe-utils/dist/lodash'
import { getCouponsInfo } from '@utils'
import { IonContent, IonFooter, IonModal, IonHeader, IonSlides, IonSlide } from '@ionic/react'
import { MktButton, CardIntegralEquity } from '@cps'
import { memberMobx, storeMobx } from '@mobxStore'
import { format } from '@dt/fe-utils'
import MemberCardApi from '@api/memberCard.api'
import ActivityApi from '@api/activity.api'
import mktController from 'controllers/mktController'
import LevelTable from '../LevelTable'
import CateTab from '../CateTab'
import './index.scss'

interface IProps {
  cardInfo: any;
  isHas?: 0 | 1;
  reject?: any;
  resolve?: (res: {
    error?: boolean;
    url?: string;
  }) => void;
}

const MemberCardDetail: FC<IProps> = (props) => {
  const detailCate = [
    {
      label: i18n.t('mkt.member.memberDetails'),
      value: 0
    },
    {
      label: i18n.t('mkt.member.levelDetails'),
      value: 1
    }
  ]
  const deductionRules = {
    rechargeFirst: i18n.t('mkt.member.deductionRule2'),
    average: i18n.t('mkt.member.deductionRule1'),
    giveFirst: i18n.t('mkt.member.deductionRule3')
  }
  const { cardInfo, isHas = 0, reject, resolve } = props
  const { storeIdToStore, storeList } = storeMobx
  const [levelInfo, setLevelInfo] = useState<any[]>([])
  const [curSlide, setCurSlide] = useState(0)
  const [couponMap, setCouponMap] = useState<any>({})

  const initOpts = {
    initialSlide: curSlide,
    autoplay: false,
    loop: false,
  }
  const couponPolicys = useMemo(() => {
    if (cardInfo && cardInfo.isSendCoupon && cardInfo.couponPolicys.length > 0) {
      return keyBy(cardInfo.couponPolicys, (item: any) => {
        if (item.sendType === 'action') {
          return `${item.sendType}_${item.sendValue}`
        } else {
          return item.sendType
        }
      })
    } else {
      return {}
    }
  }, [cardInfo])
  const handleStoreName = (isAllStore: boolean, storeIds: any[]) => {
    if (isAllStore) {
      return storeList.map((i: any) => {
        return i.storeName
      })
    } else {
      const list = map(storeIds, (i: any) => {
        const findItem = storeIdToStore[i]
        return findItem ? findItem.storeName : ''
      })
      return list
    }
  }
  const getCoupDetail = (coupons: any[]) => {
    const list: any[] = []
    map(coupons, (i: any) => {
      if (couponMap[i.couponId]) list.push(`${couponMap[i.couponId].couponName}${i.couponCnt > 1 ? ` (x${i.couponCnt})` : ''}`)
    })
    return list
  }
  const getCard = () => {
    mktController.checkLogin().then(() => {
      memberMobx.acquireMemberCard(cardInfo.cardId).then((res: any) => {
        if (res.error) {
          resolve({ error: true })
        } else {
          resolve({ url: '' })
        }
      })
    }, () => {
      resolve({ url: 'login' })
    })
  }
  const buyCard = () => {
    mktController.checkLogin().then(() => {
      resolve({
        url: `/iCard/cardOpen/open/${cardInfo.cardId}`
      })
    }, () => {
      resolve({ url: 'login' })
    })
  }
  // Component Effect
  useEffect(() => {
    if (cardInfo && cardInfo.isSendCoupon && cardInfo.couponPolicys.length > 0) {
      let coupons: any = []
      cardInfo.couponPolicys.map((item: any) => {
        coupons = coupons.concat(item.coupons)
      })
      if (coupons.length > 0) {
        ActivityApi.getCouponsList({ couponIds: getCouponsInfo(coupons) }).then((res: any) => {
          if (res?.length > 0) {
            setCouponMap(keyBy(res, 'couponId'))
          }
        })
      }
    }
  }, [cardInfo])
  useEffect(() => {
    MemberCardApi.getLevelCardList(cardInfo.cardId).then((res: any) => {
      if (!res.error) {
        if (res.length > 1 || res[0].isLevel) {
          setLevelInfo(res)
        } else {
          setLevelInfo([])
        }
      }
    })
  }, [])
  return (
    <IonModal
      cssClass='member-card-detail'
      isOpen
      showBackdrop
      swipeToClose
      backdropDismiss
      onDidDismiss={reject}
    >
      <IonHeader className='modal-header'>
        <span>{cardInfo.cardName}</span>
        <i className='iconfont icon-close' data-cypid='memberCardDetailClose' onClick={reject}></i>
      </IonHeader>
      {
        cardInfo.isLevel &&
          <div className='modal-category'>
            <CateTab
              list={detailCate}
              selected={curSlide}
              onChange={(val: any) => {
                if (curSlide !== val) {
                  (document.getElementById('couponSlider') as any).slideTo(val, 0)
                }
                setCurSlide(val)
              }}
            >
            </CateTab>
          </div>
      }
      <IonContent>
        {
          cardInfo &&
            <div className='modal-body'>
              <div className='mkt-detail-area'>
                <IonSlides id='couponSlider' options={initOpts} onIonSlideDidChange={(e: any) => { setCurSlide(e.target.swiper.activeIndex) }}>
                  <IonSlide>
                    <div className='slide-box'>
                      {
                      cardInfo.extra?.cardRightsDes &&
                        <div className='card-info-block'>
                          <div className='title'>{i18n.t('mkt.member.memberCardDes')}</div>
                          <div className='des'><span>{cardInfo.extra.cardRightsDes}</span></div>
                        </div>
                      }
                      {
                        (cardInfo.allowAgainLoad || cardInfo.allowCustomizeLoad) &&
                          <div className='card-info-block'>
                            <div className='title'>{i18n.t('mkt.member.memberCardRecharge')}</div>
                            <div className='des'>
                              {window.bo === 'cn' && <div>{i18n.t('mkt.member.mallConsume')}: {cardInfo.supportMallPay ? i18n.t('mkt.common.available') : i18n.t('mkt.common.unavailable')}</div>}
                              {window.bo !== 'cn' && <div>{i18n.t('mkt.member.tipPayment')}: {cardInfo.isPayTip ? i18n.t('mkt.common.available') : i18n.t('mkt.common.unavailable')}</div>}
                              <div>{i18n.t('mkt.member.deductionRules')}: {deductionRules[cardInfo.deductionRule]}</div>
                            </div>
                          </div>
                      }
                      {
                        (cardInfo.discountType || cardInfo.mallDiscountType) &&
                          <div className='card-info-block'>
                            <div className='title'>{i18n.t('mkt.member.memberDiscountBenefits')}</div>
                            {cardInfo.discountType && <div className='des'>{cardInfo?.products?.length ? i18n.t('mkt.member.someMealConsumeGet') : i18n.t('mkt.member.mealConsumeGet')}: {cardInfo.discountType === 'memberPrice' ? i18n.t('checkout.memberPrice') : format.toDiscount('discountRate', cardInfo.discountValue)}</div>}
                            {cardInfo.mallDiscountType && <div className='des'>{cardInfo?.mallProducts?.length ? i18n.t('mkt.member.someMallConsumeGet') : i18n.t('mkt.member.mallConsumeGet')}: {cardInfo.mallDiscountType === 'memberPrice' ? i18n.t('checkout.memberPrice') : format.toDiscount('discountRate', cardInfo.mallDiscountValue)}</div>}
                          </div>
                      }
                      {
                        cardInfo.isIntegral &&
                          <div className='card-info-block'>
                            <div className='title'>{i18n.t('cart.integralRule')}</div>
                            <div className='des'>
                              <CardIntegralEquity cardInfo={cardInfo} />
                            </div>
                          </div>
                      }
                      <div className='card-info-block'>
                        <div className='title'>{i18n.t('mkt.member.applyStore')}</div>
                        <div className='des'>
                          {handleStoreName(cardInfo.isAllStore, cardInfo.storeIds).join(',')}
                        </div>
                      </div>
                      {
                        couponPolicys.time &&
                          <div className='card-info-block'>
                            <div className='title'>{i18n.t('mkt.member.couponSend')}</div>
                            <div className='des'>
                              <div>{i18n.t(`mkt.member.sendTime${couponPolicys.time.sendValue}`)}</div>
                              <div>{getCoupDetail(couponPolicys.time.coupons).join(',')}</div>
                            </div>
                          </div>
                      }
                      {
                        (couponPolicys.action_renewAndReceive || couponPolicys.action_receive) &&
                          <div className='card-info-block'>
                            <div className='title'>{i18n.t('mkt.member.buyCard')}</div>
                            <div className='des'>
                              <div>{i18n.t('mkt.member.buySend')}</div>
                              <div>{getCoupDetail((couponPolicys.action_renewAndReceive || couponPolicys.action_receive).coupons).join(',')}</div>
                            </div>
                          </div>
                      }
                      {
                        (couponPolicys.action_renewAndReceive || couponPolicys.action_renew) &&
                          <div className='card-info-block'>
                            <div className='title'>{i18n.t('mkt.member.openIssue')}</div>
                            <div className='des'>
                              <div>{i18n.t('mkt.member.renewSend')}</div>
                              <div>{getCoupDetail((couponPolicys.action_renewAndReceive || couponPolicys.action_renew).coupons).join(',')}</div>
                            </div>
                          </div>
                      }
                    </div>
                  </IonSlide>
                  {
                    !!levelInfo.length &&
                      <IonSlide>
                        <div className='card-info-block'>
                          <div className='title'>{i18n.t('mkt.member.levelCardTit')}</div>
                          <div className='des'>
                            <LevelTable levelInfo={levelInfo}></LevelTable>
                          </div>
                        </div>
                      </IonSlide>
                  }
                </IonSlides>
              </div>
            </div>
        }
      </IonContent>
      {
        cardInfo && isHas === 0 &&
          <IonFooter>
            <div className='page-footer'>
              {
                cardInfo.type === 'paid'
                  ? (<MktButton text={i18n.t('mkt.member.buyCards')} className='buy' data-cypid='memberCardDetailBuy' onClick={buyCard}></MktButton>)
                  : (<MktButton text={i18n.t('mkt.member.freeClaim')} className='buy' data-cypid='memberCardDetailGet' onClick={getCard}></MktButton>)
              }
            </div>
          </IonFooter>
      }
    </IonModal>
  )
}

export default observer(MemberCardDetail)
